import FormDialog from '@/components/ui/form-dialog';
import { Level, Location } from '@/core/entities';
import { useDeleteLocation } from '@/queries/locations';
import useToastMessage from '@/shared/context/toast-message-context';
import { capitalize } from '@mui/material';
import { FunctionComponent, ReactElement } from 'react';

interface DeleteLocationFormProps {
	open: boolean;
	onClose: () => void;
	location?: Location;
	level?: Level;
	onSubmitted?: () => Promise<void> | void;
}

const DeleteLocationForm: FunctionComponent<DeleteLocationFormProps> = ({
	open,
	onClose,
	location,
	level,
	onSubmitted,
}): ReactElement => {
	const { dispatch } = useToastMessage();

	const { isLoading, mutate } = useDeleteLocation({
		onSuccess: async () => {
			await onSubmitted?.();
			dispatch({
				type: 'success',
				content: `${capitalize(level?.name || '')} successfully deleted`,
			});
			onClose();
		},
	});

	if (!location || !level) {
		return <></>;
	}

	return (
		<FormDialog
			title={`Remove ${level?.name}`}
			open={open}
			onClose={onClose}
			actions={{
				confirm: { label: `Remove ${level.name}`, isLoading },
				cancel: { label: 'Cancel' },
			}}
			onSubmit={() => mutate(location.id)}
		>
			{`Are you sure you wish to delete ${level.name} ${location.name}? This action cannot be undone.`}
		</FormDialog>
	);
};

export default DeleteLocationForm;
